export function mascaraNumeroMp(numeroMP: string): string {
	if (numeroMP === '') {
		return '';
	}
	const parteInicial = `${numeroMP.slice(0, 4)}.`;
	const parteFinal = `/${numeroMP.slice(-4)}`;
	const parteMeio = numeroMP.slice(4, -4);
	return parteInicial + parteMeio + parteFinal;
}
